import {html, LitElement} from "@isceco/widget-library2/external/lit";
import Plotly from 'plotly.js-dist-min';
import {ref} from "@isceco/widget-library2/external/lit/directives/ref";

export class TimeChart extends LitElement {

  static get properties() {
    return {
      i18n: {type: Object},
      title: {type: String},
      data: {type: Object},
      xAutoTicks: {type: Boolean, default: false},
      xTitle: {type: String},
      yTitle: {type: String},
    }
  }

  constructor() {
    super()
    this.i18n = {}
  }

  render() {
    return html`
      <div ${ref(el => this.drawPlot(el))} id="plot" style="overflow: hidden;"></div>
    `
  }

  // Override createRenderRoot to disable shadow DOM
  createRenderRoot() {
    return this
  }

  drawPlot(plotElement) {
    if (!plotElement || !Plotly || !this.data) {
      return
    }

    const xTickValues = this.getTickValues()
    const layout = {
      showlegend: true,
      hoverlabel: {
        namelength: 0 // Line label is already in Legends
      },
      title: {
        text: this.title
      },
      xaxis: {
        title: {
          text: this.xTitle
        },
        type: 'date',
        tickmode: this.xAutoTicks ? 'auto' : 'array',
        tickvals: xTickValues,
        tickformat: '%d.%m.%Y',
        ticklabelstandoff: 10,
      },
      yaxis: {
        title: {
          text: this.yTitle
        },
        ticksuffix: 'Wh',
        tickformat: '.4~s',
        fixedrange: true,
        rangemode: 'tozero',
        zeroline: true,
        zerolinewidth: 2,
      }
    }

    const config = {
      displaylogo: false,
      modeBarButtonsToRemove: ['lasso', 'select', 'auto', 'zoom2d', 'pan2d', 'zoomIn2d', 'zoomOut2d'/*, 'autoScale2d'*/, 'resetScale2d'],
    }

    Plotly.newPlot(plotElement, this.data, layout, config);

    setTimeout(() => {
      Plotly.Plots.resize(plotElement)
    }, 100)

  }

  getTickValues() {
    if(!this.xAutoTicks && this.data[0]?.x) {
      return this.data[0].x
    } else {
      this.xAutoTicks = true
      return []
    }
  }

}

customElements.define('eko-frontend-timechart', TimeChart)
